<script>
  import CheckBox from '../../../lib/components/CheckBox.svelte';
  import InputWithValidation from '../../../lib/components/InputFieldTarget.svelte';
  import TextField from '../../../lib/components/TextField.svelte';
  import APIClient from '../../../state-charts/api-client';
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session';
  import { fly } from 'svelte/transition';
  import Selector from '../../../lib/components/Selector.svelte';
  import { show_message } from '../../../lib/flash';
  import Switch from '../../../lib/components/SvelteSwitch.svelte';
  import { show_tutorial_screen } from '../../../lib/tutorials';
  import _ from 'lodash';
  // import {debounce} from '../../../lib/utils';
  // component options  ------------------------------------------------------ //

  export let team_code;
  export let is_team_code_valid;
  export let worker_email = '';
  export let is_email_valid;
  export let public_teams;
  export let private_team_id;
  export let private_team_name;
  export let is_virtual;
  export let page_state;
  export let order;
  export let next_tab_disabled = false;
  export let worker_invalid_team = false;
  export let is_team_selector_opened = false;
  export let has_main_init = false;

  // internal variables ------------------------------------------------------ //

  let field_blocks = [];
  let private_team = null;
  let team_selector;
  let selected_team;
  let selected_worker;
  let selected_worker_str = '';
  let init_copy = false;
  let desc;

  // utility functions -------------------------------------------------------- //

  let target_ord;
  let inv_tcode;
  let desc_req;
  let start_type;
  let task_type;
  let addteam;
  let addworker;
  let invworker;
  let textworker;
  let btn_prev;
  let btn_next;
  let teamname;
  let workername;
  let distancework_cbox;
  let label_accref;
  let invalid_additional_label;
  let new_order_required_information;
  let new_order_optional_information;
  let new_order_target_order;
  let tooltips_distance_work;
  let tooltips_target_public_team;
  let tooltips_target_order_teams;
  let tooltips_target_order_worker;

  let entertask;
  let pick;
  let addinfo;
  let addteamcode;
  let noteamsyet;
  let field_flag = false;
  let running_email = false;
  let running_code = false;
  // utility functions -------------------------------------------------------- //

  const get_private_team = async () => {
    if(team_code.length > 0){
      let data = {
        code: team_code,
      };

      let result = await APIClient.get_private_team(data);
      if (result) {
        if (!!result.name && result.name === 'APIClientError') {
          is_team_code_valid = false;
          field_blocks[0].fields[0].valid = false;
        } else {
          private_team = result;
          private_team_id = private_team.team_id;
          private_team_name = private_team.name;
          is_team_code_valid = true;
          field_blocks[0].fields[0].valid = true;
          field_blocks[0].fields[0].after_valid_text = get_selected_team_string(
            private_team_name
          );
        }
    }

    } else{
      is_team_code_valid = true;
      field_blocks[0].fields[0].valid = true;
    }
  };

  const get_selected_team_string = name => {
    return t9n(TS.NEW_ORDER_DESC_TEAMNAME) + ' ' + name;
  };

  const get_selected_worker_string = name => {
    return name;
  };

  let error_flag = false;

  const check_worker_email = async (worker_email) => {
    if(worker_email.length > 0){
      let private_array = [];
      if (private_team_id !== null && team_code.length > 0) {
        private_array.push(private_team_id);
      }

      let teams = [];
      for (let i = 0; i < public_teams.length; i++) {
        if (public_teams[i].selected === true)
          teams.push(public_teams[i].team_id);
      }

      let data = {
        email: worker_email,
        merchant_uuid: $session.merchant.merchant_uuid,
        teams: {
          private: private_array,
          public: teams,
        },
      };


      let result = await APIClient.verify_email_worker(data);
      if (result) {
        if (!!result.name && result.name === 'APIClientError') {
          is_email_valid = false;
          field_blocks[0].fields[1].valid = false;
        } else {
          selected_worker = result.first_name + ' ' + result.last_name;
          field_blocks[0].fields[1].after_valid_text = selected_worker;
          is_email_valid = true;
          field_blocks[0].fields[1].valid = true;
        }

        if (!!result.details && !!result.details.error_data) {
          if (result.details.error_data[0].code === 'order_worker_not_in_teams') {
            if(!error_flag){
              error_flag = true;
              show_message(t9n(TS.ORDER_WORKER_TEAM_INVALID), 'error');
            }
            worker_invalid_team = true;
          } else {
            error_flag = false;
            worker_invalid_team = false;
          }
        }
      }
    } else{
      is_email_valid = true;
      field_blocks[0].fields[1].valid = true;
    }

  };

  const translate_texts = () => {
    // target_ord = t9n(TS.NEW_ORDER_DESC_TARGET);
    inv_tcode = t9n(TS.NEW_ORDER_DESC_INV_TEAMCODE);
    desc_req = t9n(TS.NEW_ORDER_DESC_DESC_REQ);
    start_type = t9n(TS.NEW_ORDER_DESC_START);
    task_type = t9n(TS.NEW_ORDER_DESC_TASK_TYPE);
    addteam = t9n(TS.NEW_ORDER_DESC_ADDTEAM);
    addworker = t9n(TS.NEW_ORDER_DESC_ADDWORKER);
    invworker = t9n(TS.NEW_ORDER_DESC_INV_WORKER);
   //  textworker = t9n(TS.NEW_ORDER_DESC_TEXT_WORKER);
    btn_next = t9n(TS.TABLE_BUTTON_NEXT);

    entertask = t9n(TS.NEW_ORDER_LABEL_ENTER_TASK);
    pick = t9n(TS.NEW_ORDER_LABEL_PICK);
    addinfo = t9n(TS.NEW_ORDER_LABEL_ADD_INFO);
    addteamcode = t9n(TS.NEW_ORDER_LABEL_ADD_TEAM_CODE);
    noteamsyet = t9n(TS.NEW_ORDER_DESC_NOTEAMS);
    teamname = t9n(TS.NEW_ORDER_DESC_TEAMNAME);
    workername = t9n(TS.NEW_ORDER_DESC_WORKERNAME);
    distancework_cbox = t9n(TS.ORDERS_IS_VIRTUAL_CBOX);
    label_accref = t9n(TS.ORDER_ACC_REF);
    invalid_additional_label = t9n(TS.INVALID_INPUT);
    new_order_required_information = t9n(TS.NEW_ORDER_REQUIRED_INFORMATION);
    new_order_optional_information = t9n(TS.NEW_ORDER_OPTIONAL_INFORMATION);
    new_order_target_order = t9n(TS.NEW_ORDER_TARGET_ORDER);
    btn_prev = t9n(TS.TABLE_BUTTON_PREV);
    desc = t9n(TS.NEW_ORDER_TARGET_DESC);
    tooltips_distance_work = t9n(TS.TOOLTIPS_DISTANCE_WORK);
    tooltips_target_public_team = t9n(TS.TOOLTIPS_TARGET_PUBLIC_TEAM);
    tooltips_target_order_teams = t9n(TS.TOOLTIPS_TARGET_ORDER_TEAMS);
    tooltips_target_order_worker = t9n(TS.TOOLTIPS_TARGET_ORDER_WORKER);
  };

  const init_fields = () => {

    let target_fields = [
      {
        field_type: 'text',
        id: 'team-code',
        type: 'text',
        label: addteamcode,
        value: team_code,
        after_valid_text: selected_team,
        validate: false,
        valid: !team_code || (!!team_code && is_team_code_valid),
        validation_text: inv_tcode,
        is_tooltip_default: !page_state,
        tooltip_default_text: tooltips_target_order_teams,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        width: '410px',
        is_required: false,
        has_focused: false
      },
      {
        field_type: 'text',
        id: 'worker-email',
        type: 'text',
        label: addworker,
        value: worker_email,
        after_valid_text: selected_worker_str,
        validate: false,
        valid: !worker_email || (!!worker_email && is_email_valid),
        validation_text: invworker,
        is_tooltip_default: !page_state,
        tooltip_default_text: tooltips_target_order_worker,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        width: '410px',
        is_required: false,
        has_focused: false
      },
      //todo add public teams check
      {
        field_type: 'select-checkbox',
        id: 'team-selector',
        label: addteam,
        items: public_teams,
        type_text: start_type,
        tooltip_default_text: tooltips_target_public_team,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        value: team_selector,
        label_width: '120px',
        validate: false,
        width: '410px',
        has_focused: false
      },
      {
        field_type: 'checkbox',
        tooltip_default_text: tooltips_distance_work,
        value: is_virtual,
        id: 'virtual-cbox',
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        label: distancework_cbox,
        has_focused: false
      },
    ];

    field_blocks = [
      {
        name: t9n(TS.NEW_ORDER_TARGET_ORDER),
        fields: target_fields,
      },
    ];

    field_flag = true;

    if (JSON.parse(window.localStorage.getItem('WP.tutorial.new_order'))) {
      show_tutorial_screen(true, 'new_order_o5', 200, 'orderer');
    }
  };

  const set_field_values = () => {
    team_code = field_blocks[0].fields[0].value;
    worker_email = field_blocks[0].fields[1].value;
    team_selector = field_blocks[0].fields[2].value;
    is_virtual = field_blocks[0].fields[3].value;

  };

  const toggle_teams = () => {
    is_team_selector_opened = !is_team_selector_opened;
  }

  // $: console.log('public_teams', public_teams);

  window.open_teams = () => {
    if(!!public_teams){
      public_teams.forEach(e => {
        if(e.selected) is_team_selector_opened = true;
      })
    }
  }

  // reactive functions ------------------------------------------------------- //


  $: if (has_main_init && !field_flag) {
    translate_texts();
    init_fields();
  }

  $: if (team_code.length > 0 && worker_email.length > 0) {
    if (worker_invalid_team) {
      field_blocks[0].fields[1].valid = false;
    }
  }

  $: if (selected_worker)
    selected_worker_str = get_selected_worker_string(selected_worker);

  $: if (field_flag && field_blocks && init_copy) {
    set_field_values();
  }

  $: if (field_flag && field_blocks) {
    set_field_values();
  }



  $: if(worker_email.length > 0){
    if($session.route === '/order-new'){
      if(!running_email){
        running_email = true;
        let debounce_fun = _.debounce(async () => {
          await check_worker_email(worker_email)
          running_email = false;
        }, 1500);

        debounce_fun();
      }
    } else {
      worker_email = '';
    }
  }

  $: if(team_code.length > 0){
    if($session.route === '/order-new'){
      if(!running_code){
        running_code = true;
        let debounce_fun = _.debounce(async () => {
          await get_private_team(team_code)
          running_code = false;
        }, 1500);

        debounce_fun();
      }
    } else {
      team_code = '';
    }
  }

  $: if (
    has_main_init &&
    !!public_teams &&
    !init_copy &&
    (page_state === 'copy' || page_state === 'edit')
  ) {
    init_fields();
    init_copy = true;
    window.open_teams();
  }

</script>

<div id='description-card' class="center-mobile">
  {#each field_blocks as block, i}
    <p>{block.name}</p>

    <!-- Help line -->
    <div
      id="help-liner"
      class="fade-in-long"
      style="margin-top: -4px; margin-bottom: 15px">
      <div class="tooltip-default">
        <div
          id="tooltip_def"
          class="tooltip-text tooltip-top"
          style="background-color:var(--mdc-theme-secondary); color: rgb(255,
          255, 255);">
          {desc}
        </div>
      </div>
    </div>

    <div class="flex">
      {#each block.fields as field, j}
        {#if field.field_type === 'text'}
          <div data-tooltip={field.tooltip_default_text} class="responsive-input" style="margin-right: 30px">
            <InputWithValidation
              id={field.id}
              type={field.type}
              label={field.label}
              max_char={field.max_char}
              validate={field.validate}
              bind:value={field.value}
              disabled={field.disabled}
              tooltip_default_text={field.tooltip_default_text}
              validation_text={field.validation_text}
              after_valid_text={field.after_valid_text}
              valid={field.valid}
              is_required={field.is_required}
              bind:has_focused={field.has_focused}
            />
          </div>
        {/if}
        {#if field.field_type === 'selector'}
          <div class="selector-margin responsive-input" style="margin-bottom: 16px;">
            <Selector
              id={field.id}
              label={field.label}
              variant={field.variant}
              valid={field.valid}
              showed_elements=5
              invalid_text={field.invalid_text}
              disabled={field.disabled}
              items={field.items}
              bind:has_focused={field.has_focused}
              is_required={field.is_required}
              bind:input_value={field.input_value}
              bind:value={field.value} />
          </div>
        {/if}
        {#if field.field_type === 'textarea'}
          <div class='responsive-input' style="margin-right: 30px; margin-bottom: 16px">
            <TextField
              bind:value={field.value}
              label={field.label}
              max_chars={field.max_chars}
              show_counter={field.show_counter}
              height={field.height}
            />
          </div>
        {/if}
        {#if field.field_type === 'select-checkbox'}
          <div data-tooltip={field.tooltip_default_text} class="checkbox-select-margin" style="width: 410px; margin-top: 10px; margin-bottom: 10px;">
            <button id="change_button" class="mdc-button mdc-button--outlined desktop-width"
                    on:click|stopPropagation|preventDefault={() => toggle_teams()}>
              <span class="mdc-button__ripple"/>
              {addteam}
            </button>

            {#if is_team_selector_opened}
              <div  transition:fly={{ y: -50, duration: 250 }}
                    style='margin-top: 20px; padding: 5px; overflow-y: auto;
                    max-height: 172px; margin-bottom: 10px;'>
                {#each field.items as item, i}
                  <div style="margin-bottom: 10px">
                    <Switch
                      label={item.name}
                      bind:checked={item.selected} />
                  </div>
                {/each}
              </div>
            {/if}
          </div>
        {/if}

        {#if field.field_type === 'checkbox'}
          <div class="virtual-cbox checkbox-margin" data-tooltip={field.tooltip_default_text}>
            <CheckBox
              bind:value={field.value}
              id={field.id}
              disabled={field.disabled}
              label={field.label} />
          </div>
        {/if}
      {/each}
    </div>
  {/each}
</div>

<!-- Back + Next -->
<div style="display: flex; justify-content: flex-end">

  <button
    onclick="prev_tab()"
    style="margin-right: 10px;"
    class="mdc-button mdc-button--outlined margin-5">
    <span class="mdc-button__ripple" />
    {btn_prev}
  </button>

  <button
    id="next_button"
    onclick="next_tab()"
    disabled={next_tab_disabled}
    class="mdc-button mdc-button--unelevated margin-5">
    <span class="mdc-button__ripple" />
    {btn_next}
  </button>

</div>

<style>
    .virtual-cbox {
        margin-left: -10px;
        margin-top: 5px;
    }

    /* Tooltip
    *******************************************************/

    .tooltip-default {
        position: relative;
        font-size: 12px;
        /*top: -60px;*/
        animation: transition_in 0.6s;
    }

    .tooltip-default .tooltip-top {
        /*position: absolute;*/
        z-index: 1;
        bottom: 100%;
        right: 0;
        left: 50%;
    }

    .tooltip-default .tooltip-text {
        background-color: var(--mdc-theme-secondary);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 8px 8px;
        display: block;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 13px;
        box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
    }

    .tooltip-default .tooltip-text::before {
        content: ' ';
        position: relative;
        top: -30px;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent #018786 transparent;
    }

    /* Desktop Mode
    *******************************************************/

    @media (min-width: 1025px) {
        .center-mobile {
            padding-left: 50px;
            padding-right: 50px;
        }

        .responsive-input {
            width: 410px;
        }

        .flex {
            width: 880px;
            display: flex;
            flex-wrap: wrap;
        }

        .mdc-layout-grid__cell--span-5 {
            margin-left: 10px;
        }

        .native-sel-width {
            width: 99.6% !important;
        }

        .mobile-margin {
            margin-left: 0;
        }

        .checkbox-margin {
            margin-right: 30px;
            width: 420px;
            margin-top: 15px;
        }

        .selector-margin {
            margin-right: 30px;
            margin-bottom: 16px;
        }

        .checkbox-select-margin {
            margin-right: 30px;
            margin-bottom: 16px;
        }

        .desktop-width {
            width: 410px;
        }
    }

    /* Tablet Mode
    *******************************************************/

    @media (min-width: 769px) and (max-width: 1024px) {
        .center-mobile {
            width: 50%;
            margin: auto;
            padding-left: 0px;
            padding-right: 50px;
        }

        .responsive-input {
            width: 410px;
        }

        .mdc-layout-grid__cell--span-5 {
            margin-left: 25px;
        }

        .native-sel-width {
            width: 100% !important;
        }

        .virtual-cbox {
            margin-left: 10px;
        }

        .flex {
            width: 410px;
            display: flex;
            flex-wrap: wrap;
        }

        .checkbox-margin {
            margin-left: -7px;
        }

        .desktop-width {
            width: 410px;
        }
    }

    /* Mobile Mode
          *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {
        .select-box {
            width: 410px !important;
        }

        .desktop-width {
            width: auto;
            min-width: 238px;
        }

        .center-mobile {
            width: 35%;
            margin: auto;
            padding-left: 0px;
            padding-right: 50px;
        }

        .responsive-input {
            width: 238px;
        }

        .mdc-layout-grid {
            margin-left: 10px;
        }

        .flex {
            width: 410px;
            display: flex;
            flex-wrap: wrap;
        }

        .mobile-margin {
            margin-left: 25px;
        }

        .mdc-layout-grid__cell--span-5 {
            margin-left: 25px;
        }

        .native-sel-width {
            width: 100% !important;
        }

        .virtual-cbox {
            margin-left: 20px;
        }

        .checkbox-margin {
            margin-left: -7px;
        }

        .tooltip-default {
            width: 238px;
        }
    }
</style>
